import CommonLandingContainer from '../../../../landingComponents/containers/common';
import styles from './youWillGet.module.scss';
import {
  Heading2,
  SecondaryText,
  Heading3,
} from '../../../../landingComponents/typography';
import cell from 'src/assets/img/landing/cell.png';
import cellSmall from 'src/assets/img/landing/cellSmallPart.png';
import InfoPanel from '../../../../landingComponents/containers/infoPanel';
import { ReactComponent as LametriLogo } from 'src/assets/img/landing/Logo2.svg';
import { ReactComponent as CellCircle } from 'src/assets/img/landing/cellCircle.svg';

const YouWillGet = () => {
  return (
    <CommonLandingContainer className={styles.container}>
      <Left />
      <Right />
    </CommonLandingContainer>
  );
};

export default YouWillGet;

const Left = () => {
  return (
    <div className={styles.left}>
      <div className={styles.imageContainer}>
        <img
          className={styles.cell}
          src={cell}
          alt="Ламетри - помощник"
        />
        <CellCircle className={styles.cellCircle} alt="" />
        <LametriLogo className={styles.logo} alt="Логотип Ламетри" />
      </div>
    </div>
  );
};

const Right = () => {
  return (
    <>
      <div className={styles.right}>
        <Heading2 className={styles.title} accent>
          После обработки ваших данных вы получите:
        </Heading2>
        <div className={styles.info}>
          <InfoPanel Header={() => <Heading3 accent>Краткие выводы</Heading3>}>
            <SecondaryText>Что значат результаты ваших анализов</SecondaryText>
          </InfoPanel>
          <InfoPanel Header={() => <Heading3 accent>Оценку рисков</Heading3>}>
            <SecondaryText>К чему могут привести отклонения</SecondaryText>
          </InfoPanel>
          <InfoPanel
            Header={() => (
              <Heading3 accent>Рекомендации по специалистам </Heading3>
            )}
          >
            <SecondaryText>
              К какому специалисту следует обратиться
            </SecondaryText>
          </InfoPanel>
          <InfoPanel
            Header={() => <Heading3 accent>Выявление отклонений</Heading3>}
          >
            <SecondaryText>
              Выделение цветом значимых отклонений показателей
            </SecondaryText>
          </InfoPanel>
        </div>
      </div>
      <div className={styles.smallCellContainer}>
        <img className={styles.cellSmall} src={cellSmall} alt="" />
        {/* <CellCircle className={styles.smallcellCircle} alt="" /> */}
      </div>
    </>
  );
};
